import DataTable from "datatables.net-react";
import { Card, Col, Row } from "react-bootstrap";
import Button from 'react-bootstrap/Button';

function bulktrtading(){

    return(
        <div className="container-fluid">    
        <Card className="mt-2">
          <Card.Body>
              <Row>
                
                <Col>
                <b className="fss-05">NO OF TRADES</b>
                     <input type="number" className="bg-white text-black"/>
                </Col>

                <Col className="mt-4">
                   <Button variant="secondary" size="sm" className="w-auto">
                     + Submit
                   </Button>
                </Col>
                <Col></Col>
                <Col></Col>
                <Col></Col>
                <Col></Col>
                <Col></Col>
                <Col></Col>
                <Col></Col>
                <Col></Col>
              </Row>
          </Card.Body>
        </Card>

        <Card className="mt-2">
          <Card.Body>
          <div className="table-responsive">
              <DataTable className=' striped bordered'>
                      <thead>
                        <tr>
                          <th className='bg-secondary fss-05' >SCRIPT</th>
                          <th className='bg-secondary fss-05' >NO OF TRADES</th>
                          <th className='bg-secondary fss-05' >START TIME</th>
                          <th className='bg-secondary fss-05' >END TIME</th>
                          </tr>
                      </thead>
                    
                    </DataTable>
                    </div>
             </Card.Body>
        </Card>
   </div>
    )
}
export default bulktrtading